;
var myaNameSpace = myaNameSpace || {};
myaNameSpace.addMyaTracking = function () {

    window.StStEvents = window.StStEvents || {};
    window.StStEvents.publish = window.StStEvents.publish || function (objType, payload) {
        const event = (typeof payload === 'undefined') ? new Event(objType) : new CustomEvent(objType, { detail: payload });
        document.dispatchEvent(event);
    }

    const adobeEvents = [
        { name: "MYA.WIDGET.BOOTED", domEvent: "MYA.WIDGET.BOOTED", target: document, adobeEvent: "event988", trackOnce: false, linkedEvent: [], eVarsList: [1, 23, 30, 223], sourceName: "" },
        { name: "MYA.WIDGET.EXPANDED", domEvent: "MYA.WIDGET.EXPANDED", target: document, adobeEvent: "event998", trackOnce: true, linkedEvent: [], eVarsList: [1, 23, 30, 223], sourceName: "" },
        { name: "MYA.USER.MESSAGE.SUBMITTED", domEvent: "MYA.USER.MESSAGE.SUBMITTED", target: document, adobeEvent: "event999", trackOnce: true, linkedEvent: ["MYA.CONVERSATION.BUTTON.CLICKED"], eVarsList: [1, 23, 30, 223], sourceName: "" },
        { name: "MYA.CONVERSATION.BUTTON.CLICKED", domEvent: "MYA.CONVERSATION.BUTTON.CLICKED", target: document, adobeEvent: "event999", trackOnce: true, linkedEvent: ["MYA.USER.MESSAGE.SUBMITTED"], eVarsList: [1, 23, 30, 223], sourceName: "" },
    ];

    const main = function () {
        setupListeners(adobeEvents);

        if (document.readyState === 'complete') {
            loadLateEvents();
        } else {
            window.addEventListener("load", loadLateEvents);
        }
    };

    const loadLateEvents = function () {
        const eventList = [];
        extendEventList(eventList);
        removeExistingApplyBtsListeners(eventList);
        setupListeners(eventList);
        extendEventList(adobeEvents);
    };

    const removeExistingApplyBtsListeners = function(eventsList) {
        eventsList.forEach(function (objEvent) { $("#"+objEvent.name).off() });
    };

    const extendEventList = function (eventsList) {
        eventsList.push({ name: "JobToolsTop_AOLOptions_lnkApplyOnline", domEvent: "click", target: document.getElementById("JobToolsTop_AOLOptions_lnkApplyOnline"), adobeEvent: "event28".concat((s.eVar7 === 'First Party') ? ",event35" : ""), trackOnce: true, linkedEvent: [], eVarsList: [1, 7, 23, 190, 223], sourceName: "Top_Button" });
        eventsList.push({ name: "JobToolsBottom_AOLOptions_lnkApplyOnline", domEvent: "click", target: document.getElementById("JobToolsBottom_AOLOptions_lnkApplyOnline"), adobeEvent: "event28".concat((s.eVar7 === 'First Party') ? ",event35" : ""), trackOnce: true, linkedEvent: [], eVarsList: [1, 7, 23, 190, 223], sourceName: "Bottom_Button" });
    }

    const setupListeners = function (eventsList) {
        eventsList.forEach(function (objEvent) { listenToEvent(objEvent); });
    };

    const listenToEvent = function (objEvent) {
        if (typeof objEvent !== undefined && objEvent.target !== null) {
            objEvent.target.addEventListener(
                objEvent.domEvent,
                actionEvent,
                (objEvent.trackOnce) ? { once: true } : false
            )
        }
    };

    const actionEvent = function (eventItem) {
        trackAdobeEvent(eventItem);
        removeTrackOnceEventListener(eventItem);
    };

    const trackAdobeEvent = function (eventItem) {
        const eventObject = getEventObjectFromConfig((eventItem.type == "click") ? eventItem.target.id : eventItem.type);
        if (typeof s !== undefined) {
            if (eventObject.sourceName) s.eVar190 = eventObject.sourceName;
            s.linkTrackVars = eventObject.eVarsList.map(function (eVar) { return "eVar" + eVar }).join(',');
            var eventsList = eventObject.adobeEvent;
            s.linkTrackEvents = eventsList;
            s.events = eventsList;
            s.tl(true, "o", getEventDescription(eventObject));
        } else {
            console.log("AppMeasurement not ready or found!");
        }
    };

    const removeTrackOnceEventListener = function (eventItem) {
        const adobeEvent = getEventObjectFromConfig((eventItem.type == "click") ? eventItem.target.id : eventItem.type);

        if (adobeEvent.trackOnce) {
            removeListener(adobeEvent.name);
            adobeEvent
                .linkedEvent.forEach(
                    function (eventName) {
                        removeListener(eventName);
                    }
                )
        }
    }

    function removeListener(eventName) {
        document.removeEventListener(eventName, actionEvent, false);
    }

    const getEventDescription = function (eventObject) {
        return (eventObject.domEvent === "click") ? "Click on Apply" : eventObject.domEvent;
    }

    const getEventObjectFromConfig = function (objectEventName) {
        return adobeEvents.filter(function (eventObject) { return eventObject.name === objectEventName; })[0];
    }

    main();
};

myaNameSpace.trackMyaApplyBtnCllBck = function () {
    console.log('Application button clicked!');
    const applyEvent = {
        name: "Mya Click on Apply",
        adobeEvent: "",
        eVarsList: [1, 7, 23, 190, 223],
        eventsList: [28]
    };

    if (typeof s !== undefined) {
        const eVarsList = applyEvent.eVarsList.map(function (eVar) { return "eVar" + eVar }).join(',');
        s.linkTrackVars = eVarsList + ",events";

        var eventsList = applyEvent.eventsList.map(function (eventId) { return "event" + eventId }).join(',');
        if (s.eVar7 === 'First Party') { eventsList += ",event35" };
        s.eVar190 = "Mya_Button";
        s.linkTrackEvents = eventsList;
        s.events = eventsList;

        s.tl(true, "o", applyEvent.name);
    } else {
        console.log("AppMeasurement not ready or found!");
    }

    const elem = document.getElementById("jobId");
    if(elem) window.location.replace("/job/" + elem.value + "/apply");
    
};